module.exports = __webpack_public_path__ + "img/snappicture_04.b6e6bbc7.jpg";